const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Imóveis",
    to: "/imoveis",
  },
  {
    text: "Terrenos",
    to: "/terrenos",
  },
  {
    text: "Locação",
    to: "/locacao",
  },
  {
    text: "Rural",
    to: "/rural",
  },
];

const menuTop = [
  {
    text: "Cadastre seu Imóvel",
    to: "/cadastre-seu-imovel",
  },
  {
    text: "Sobre",
    to: "/sobre",
  },
  {
    text: "Fale Conosco",
    to: "/fale-conosco",
  },
];

export { server, menuTop, menu };
